import Vue from 'vue';
import Component from 'vue-class-component';
import template from './create-team-invite.html';
import './create-team-invite.scss';
import {IDialogComponent} from "@ponte/dialog-vue";
import {IDialog} from '@ponte/dialog';
import DialogTemplate from '../../common/dialog/dialogs/dialog-template/dialog-template';import {TeamRole} from "respresso";
import {SlimSelectOption} from "../../common/vue-slim-select/vue-slim-select";
import AccessService from "../../../services/access-service";
import {Prop} from "vue-property-decorator";
import {translate} from "../../../main";


export interface CreateTeamInviteDialogConfig {
	myRole: TeamRole;
}

export interface CreateTeamInviteResponse {
	name: string;
	email: string;
	role: TeamRole;
}

@Component({
	components: {
		'dialog-template': DialogTemplate,
	},
	template: template,
})
export default class CreateTeamInvite extends Vue implements IDialogComponent<CreateTeamInviteResponse | undefined> {
	@Prop() dialogConfig!: CreateTeamInviteDialogConfig;
	dialog!: IDialog<CreateTeamInviteResponse | undefined>;

	public name: string = "";
	public email: string = "";
	public role: TeamRole = "MEMBER";

	public mounted(): void {
		window.addEventListener('keyup', this.handleKeyUp);
	}

	public unmounted(): void {
		window.removeEventListener('keyup', this.handleKeyUp);
	}

	private handleKeyUp(event: KeyboardEvent) {
		switch (event.key || event.keyCode) {
			case 'Escape':
			case 27:
				this.closeDialog();
				break;
			case 'Enter':
			case 13:
				if (this.saveable()) {
					this.createInvite();
				}
				break;
		}
	}

	createInvite() {
		if (this.dialog.dialogController) {
			this.dialog.dialogController.close({
				name: this.name,
				email: this.email,
				role: this.role
			});
		}
	}


	protected createRoleSelectOption(): SlimSelectOption[] {
		const myRole = this.dialogConfig.myRole;
		const roles: TeamRole[] = ["OUTSIDER", "MEMBER", "ADMIN", "OWNER"];
		return roles.map(role => {
			const option: SlimSelectOption = {
				text: this.getRole(role),
				value: role,
				selected: this.role === role,
				disabled: !AccessService.includesTeamRole(myRole, role)
			};
			return option;
		});
	}

	private getRole(role: string): string {
		return translate(`team.role.${role.toLowerCase()}.name`);
	}

	protected async roleChanged(event: any) {
		this.role = event.value as TeamRole;
		this.$forceUpdate();
	}

	closeDialog() {
		if (this.dialog.dialogController) {
			this.dialog.dialogController.close(undefined);
		}
	}

	saveable(): boolean {
		return !!this.name && !!this.name.trim() && !!this.email && !!this.email.trim();
	}
}
